import { useEffect, useRef } from 'react'

import { useDashboardFilters } from '../contexts/DashboardFiltersContext'

interface UseLoadingTrackerProps {
  isLoading: boolean
  componentId: string // Identificador único para cada componente
}

// Mapa global para rastrear el estado de carga de todos los componentes
const componentLoadingStates = new Map<string, boolean>()

export const useLoadingTracker = ({ isLoading, componentId }: UseLoadingTrackerProps) => {
  const { setLoading } = useDashboardFilters()
  const timeoutRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    // Actualizar el estado de carga de este componente específico
    componentLoadingStates.set(componentId, isLoading)

    // Limpiar timeout anterior si existe
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (!isLoading) {
      // Cuando este componente termina de cargar, esperamos un poco
      // y luego verificamos si TODOS los componentes han terminado
      timeoutRef.current = setTimeout(() => {
        // Verificar si todos los componentes han terminado de cargar
        const allComponentsLoaded = Array.from(componentLoadingStates.values()).every(
          loading => !loading,
        )

        if (allComponentsLoaded) {
          setLoading(false)
        }
      }, 1000) // Esperamos 1 segundo para que todos terminen
    }

    // Cleanup
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [isLoading, componentId, setLoading])

  // Cleanup cuando el componente se desmonta
  useEffect(() => {
    return () => {
      componentLoadingStates.delete(componentId)
    }
  }, [componentId])
}
